// loaderService.js
import { Subject } from 'rxjs';

// Create a subject that components can subscribe to
const loaderSubject = new Subject();

// Counter to track concurrent requests
let activeRequests = 0;

// Show the loader
const showLoader = () => {
  activeRequests++;
  if (activeRequests === 1) {
    // Only emit when going from 0 to 1 active requests
    loaderSubject.next(true);
  }
};

// Hide the loader
const hideLoader = () => {
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    // Only emit when all requests are complete
    loaderSubject.next(false);
  }
};

// Observable that components can subscribe to
const loaderState = loaderSubject.asObservable();

export { showLoader, hideLoader, loaderState };